import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "dialog-footer"
};
import { computed, onUpdated, ref } from 'vue';
import zh from '@/i18n/zh';
import en from '@/i18n/en';
import { useStore } from 'vuex';
export default /*#__PURE__*/_defineComponent({
  __name: 'SystemDialog',
  props: {
    title: {
      type: String,
      default: '标题',
      required: true
    },
    info: {
      type: String,
      default: '',
      required: false
    },
    width: {
      type: String,
      default: '50%'
    },
    height: {
      type: String,
      default: '250'
    },
    camera: {
      type: Boolean,
      default: false
    },
    quxiao: {
      type: Boolean,
      default: true
    },
    queding: {
      type: Boolean,
      default: true
    }
  },
  emits: ['onClose', 'onConfirm', 'onCamera'],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const store = useStore();
    const camerav = ref(false); // 拍照按钮
    const quxiao = ref(true); // 拍照按钮
    const queding = ref(true); // 拍照按钮
    console.log('sys');
    onUpdated(() => {
      camerav.value = props.camera;
    });
    const onClose = () => {
      emits('onClose');
    };
    const onConfirm = () => {
      emits('onConfirm');
    };
    const camera = () => {
      emits('onCamera');
    };
    // 根据props.title和store.getters.lang计算dialogTitle
    const dialogTitle = computed(() => {
      const {
        title,
        info
      } = props;
      const lang = store.getters.lang;
      let buttonText;
      if (title === 'add') {
        buttonText = lang === 'en' ? en.buttons.add : zh.buttons.add;
      } else if (title === 'edit') {
        buttonText = lang === 'en' ? en.buttons.edit : zh.buttons.edit;
      } else if (title === 'assignment') {
        buttonText = lang === 'en' ? en.buttons.assignment : zh.buttons.assignment;
      } else if (title === 'assignDialog') {
        buttonText = lang === 'en' ? 'Assign the role to' + `【${info}】` : '给' + `【${info}】` + '分配角色';
      } else if (title === 'authority') {
        buttonText = lang === 'en' ? 'Assign the authority to' + `【${info}】` : '给' + `【${info}】` + '分配权限';
      } else if (title === 'selectDepartment') {
        buttonText = lang === 'en' ? 'Select department' : '选择部门';
      } else if (title === 'view') {
        buttonText = lang === 'en' ? en.buttons.view : zh.buttons.view;
      }
      return buttonText;
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        "close-on-click-modal": false,
        draggable: "true",
        title: _unref(dialogTitle),
        width: __props.width,
        "before-close": onClose,
        camera: camera
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_1, [quxiao.value ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          onClick: onClose
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('buttons.cancel')), 1)]),
          _: 1
        })) : _createCommentVNode("", true), queding.value ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          type: "primary",
          onClick: onConfirm
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('buttons.confirm')), 1)]),
          _: 1
        })) : _createCommentVNode("", true)])]),
        default: _withCtx(() => [_createElementVNode("div", {
          class: "container",
          style: _normalizeStyle({
            height: __props.height + 'px'
          })
        }, [_renderSlot(_ctx.$slots, "default")], 4)]),
        _: 3
      }, 8, ["title", "width"]);
    };
  }
});